/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryRequest {
    getFixupPrototypeFunction() { return WorkloadQueryRequest.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryRequest>): WorkloadQueryRequest {
        let obj = Object.assign(new WorkloadQueryRequest(), model);
        WorkloadQueryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryRequest>): WorkloadQueryRequest {
        if (!model) return null;
        return WorkloadQueryRequest.newInstance(<WorkloadQueryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryRequest) {
        if (!obj) return;

        models.WorkloadQueryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryRequest): boolean {
        Object.setPrototypeOf(obj, WorkloadQueryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.WorkloadTierConfiguration.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.WorkloadQuerySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.WorkloadQuerySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.WorkloadTierConfiguration;

}
